import React from "react";
import { createRoot } from "react-dom/client";
import "./syncTooltip.scss";

let syncTooltipRoot = null;

const SyncTooltip = {
	loadTaxonomyString: (className) => {
		SyncTooltip.taxonomyWrapper(className);
	},

	closeOpenTaxonomyString: (event) => {
		const taxonomyContainer = document.querySelectorAll(`.synctooltip__container`);
		if (taxonomyContainer) {
			taxonomyContainer.forEach((node) => {
				// If user clicks outside the element, hide it!
				if (node.classList.contains("open--string")) {
					node.classList.remove("open--string");
				}
			});
		}
	},

	updateTaxonomyString: (event, value, dimensions, className) => {
		if (syncTooltipRoot) {
			syncTooltipRoot.unmount();
		}
		const taxonomyContainer = document.querySelector(`.${className}`);
		taxonomyContainer.classList.add("open--string");
		taxonomyContainer.setAttribute("style", `top: ${event.clientY + window.scrollY + 15}px; left: ${event.clientX - 18}px; position: absolute;`);
		syncTooltipRoot = createRoot(taxonomyContainer);
		syncTooltipRoot.render(SyncTooltip.buildDynamicString(dimensions, value));
	},

	taxonomyWrapper: (className) => {
		const body = document.querySelector("body");
		const taxonomyContainer = document.querySelector(`.${className}`);
		if (!taxonomyContainer) {
			const taxonomyWrapper = document.createElement("DIV");
			taxonomyWrapper.classList.add(className, "synctooltip__container");
			body.appendChild(taxonomyWrapper);
		}
	},

	buildDynamicString: (dimensions, value) => {
		return (
			<div className="flex__container flex--ai--c">
				<span className="synctooltip--string">{value || "N/A"}</span>
			</div>
		);
	}
};

export default SyncTooltip;
